import React from "react"
import PropTypes from "prop-types"
import Image from "../Image/Image"
import useImage from "../../../hooks/useImage"
import { PDF_CONST } from "../../../constants/label.constants"
import Typography from "../Typography/Typography"
const Link = props => {
  const {
    label,
    url,
    target,
    title,
    className = "",
    children,
    onFocus,
    onBlur,
    onClick,
    id,
    elementId,
    scrollToElementId,
    gaEventClass,
    gaEventLabel = "",
    images,
    tabIndex,
    ariaLabel = "",
    linkrole = "",
    variant = "",
    role
  } = props
  const regex = new RegExp(
    "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?"
  )

  const { altText, foregroundImg } = useImage(images)
  const isExternallink = regex.test(url)
  const isMailToLink = url?.startsWith("mailto:")
  let pageUrl
  if (url) {
    pageUrl =
      !url?.trim()?.endsWith("/") &&
      !(
        url?.trim()?.endsWith(".pdf") ||
        url?.trim()?.endsWith(".mp4") ||
        url?.trim()?.endsWith(".xlsx") ||
        isExternallink||
        isMailToLink
      ) &&
      !url.includes("?")
        ? `${url}/`
        : url
  }
  if (
    (url?.trim()?.endsWith(".pdf") ||
      url?.trim()?.endsWith(".mp4") ||
      url?.trim()?.endsWith(".xlsx")) &&
    url?.includes(PDF_CONST)
  ) {
    pageUrl = process.env.GATSBY_URL?.concat(pageUrl)
  }
  let href = !pageUrl?.includes(".") ? pageUrl?.toLowerCase() : pageUrl
  if (pageUrl && scrollToElementId) {
    href = `${pageUrl}#${scrollToElementId}`
  } else if (!pageUrl && scrollToElementId) {
    href = `#${scrollToElementId}`
  }

  const targetWindow = target || (isExternallink ? "_blank" : "_self")

  // if image is there, pass down event to image element
  const eventClassFinal = gaEventClass
    ? gaEventClass
    : isExternallink || target == "_blank"
    ? "event_external_link"
    : "event_internal_link"

  const classNameFinal = className
    ? [className, eventClassFinal].join(" ")
    : eventClassFinal
  const content = children || (
    <>
      {foregroundImg ? (
        <Image
          contentfulImage={foregroundImg}
          alt={altText}
          eventClass={gaEventClass}
          eventLabel={gaEventLabel}
        />
      ) : variant === "TYPO_LINK" ? (
        <Typography content={label || null} allow_br_tag={true} />
      ) : (
        label || null
      )}
    </>
  )

  const getAriaLabel = (ad, cd, ld) => {
    if (ad) {
      return ad
    } else if (typeof cd === "string") {
      return cd
    } else {
      return ld
    }
  }

  return (
    <a
      href={href || "#"}
      target={targetWindow}
      className={classNameFinal}
      onFocus={onFocus}
      onBlur={onBlur}
      onClick={onClick}
      data-action-detail={gaEventLabel || title || content || href}
      title={title}
      id={id || elementId}
      aria-label={getAriaLabel(ariaLabel, content, label)}
      tabIndex={tabIndex}
      role={linkrole || role}
    >
      {content || children}
    </a>
  )
}

Link.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  url: PropTypes.string,
  target: PropTypes.string,
  elementId: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  scrollToElementId: PropTypes.string,
  images: PropTypes.object,
  id: PropTypes.string,
  gaEventClass: PropTypes.string,
  gaEventLabel: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  tabIndex: PropTypes.any,
  linkrole: PropTypes.string,
  variant: PropTypes.string,
  role: PropTypes.string
}

export default Link